import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.policy[statusKey] === REDUX_ASYNC_STATUSES.LOADING;
const isFailedSelector = (statusKey) => (state) => state.policy[statusKey] === REDUX_ASYNC_STATUSES.FAILED;

export const selectPolicy = (state) => state.policy?.policy;
export const selectPolicyLoading = isLoadingSelector('policyStatus');

export const selectConnectedRisks = (state) => state.policy?.connectedRisks;
export const selectConnectedRisksLoading = isLoadingSelector('connectedRisksStatus');

export const selectCreatePolicyLoading = isLoadingSelector('createPolicyStatus');
export const selectCreatePolicyFailed = isFailedSelector('createPolicyStatus');

export const selectUpdatePolicyLoading = isLoadingSelector('updatePolicyStatus');

export const selectDeletePolicyLoading = isLoadingSelector('deletePolicyStatus');
